/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { Button, Col, Row } from "antd";
import { Link } from "react-router-dom";
import jwtDecode from "jwt-decode";

import { LengthOfStaySection_fields } from "./fields-object/fields-object";
import { OvernighGuestContext } from "./context-view";
import { overnightGuestInitalValues as initialValues } from "./initialvalues/initialValues";
import { COLORS } from "~constants";

const Index = () => {
  /*
   *  -- NOTE --
   *
   *   This View Page is only use for Overnight Guest Page and is
   *   Tightly coupled with the context of Overnight Guest Form
   *
   * * */
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;

  let { pageData } = useContext(OvernighGuestContext);
  const data = pageData?.data || initialValues;
  const [genderCount, setgenderCount] = useState();
  const [totalGuestNight, settotalGuestNight] = useState();

  useEffect(() => {
    let _totalGenderCount = { totalMale: 0, totalFemale: 0 };
    let guestExtending = data?.["lengthOfStay"]?.["guestExtending"] || 0;

    Object.keys(data).forEach((key) => {
      if (key === "nonPhResident" || key === "ofwResident") {
        data[key].forEach((item) => {
          _totalGenderCount.totalMale += item?.male || 0;
          _totalGenderCount.totalFemale += item?.female || 0;
        });
      } else if (key !== "lengthOfStay") {
        _totalGenderCount.totalMale += data[key].male;
        _totalGenderCount.totalFemale += data[key].female;
      }
    });

    settotalGuestNight(
      _totalGenderCount.totalMale +
        _totalGenderCount.totalFemale +
        guestExtending
    );
    setgenderCount(_totalGenderCount);
  }, [data]);

  return (
    <>
      {LengthOfStaySection_fields.map((field, index) => {
        if (field.name === "totalGuest") {
          return (
            <Row
              key={index}
              gutter={10}
              justify="space-between"
              align="center"
              style={{ marginBottom: 20 }}
            >
              <Col span={14}>{field.label}</Col>
              <Col span={10}>{totalGuestNight}</Col>
            </Row>
          );
        } else if (field.name === "guestCheckin") {
          return (
            <Row
              key={index}
              gutter={10}
              justify="space-between"
              align="center"
              style={{ marginBottom: 20 }}
            >
              <Col span={14}>{field.label}</Col>
              <Col span={10}>
                {(genderCount?.totalMale || 0) +
                  (genderCount?.totalFemale || 0)}
              </Col>
            </Row>
          );
        } else if (field.name === "totalFemale") {
          return (
            <Row
              key={index}
              gutter={10}
              justify="space-between"
              align="center"
              style={{ marginBottom: 20 }}
            >
              <Col span={14}>{field.label}</Col>
              <Col span={10}>{genderCount?.totalFemale || 0}</Col>
            </Row>
          );
        } else if (field.name === "totalMale") {
          return (
            <Row
              key={index}
              gutter={10}
              justify="space-between"
              align="center"
              style={{ marginBottom: 20 }}
            >
              <Col span={14}>{field.label}</Col>
              <Col span={10}>{genderCount?.totalMale || 0}</Col>
            </Row>
          );
        } else {
          return (
            <Row
              key={index}
              gutter={10}
              justify="space-between"
              align="center"
              style={{ marginBottom: 20 }}
            >
              <Col span={14}>{field.label}</Col>
              <Col span={10}>{data?.["lengthOfStay"]?.[field.name] || 0}</Col>
            </Row>
          );
        }
      })}

      {userType !== "Administrator" && (
        <Row>
          <Col span={12}>
            <Button
              htmlType="reset"
              size="large"
              style={{ backgroundColor: COLORS.green }}
            >
              <Link
                to={`/v2/${userType}/overnight-guest/${pageData?.transactionId}`}
                state={pageData}
              >
                EDIT
              </Link>
            </Button>
          </Col>
          <Col
            span={12}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            <Button
              size="large"
              htmlType="submit"
              style={{ backgroundColor: COLORS.orange }}
            >
              <Link to={`/v2/${userType}/overnight-guest`}>ADD REPORT</Link>
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Index;
